import * as d3 from 'd3';
import { IPlayerAttributesPitchData } from '../types/IPlayerAttributesData';


const getBackgroundColor = (vaepScore: number) => {
    if (vaepScore == null) {
        return "none";
    }
    if (vaepScore > 0 && vaepScore <= 19.99) {
        return "var(--UI-red-500, #FF3864)";
    } else if (vaepScore >= 20 && vaepScore <= 39.99) {
        return "var(--Brand-orange-500, #FF7800)";
    } else if (vaepScore >= 40 && vaepScore <= 59.99) {
        return "var(--UI-yellow-500, #F2E94E)";
    } else if (vaepScore >= 60 && vaepScore <= 79.99) {
        return "var(--Brand-green-2-500, #4AF075)";
    } else if (vaepScore >= 80 && vaepScore <= 100) {
        return "#00D1A8";
    } else if (vaepScore === 0) {
        return "#DADADA";
    } else {
        return "red";
    }
};
// Function to render rectangles
export const renderRiskMapForAttributes = (
    svg: d3.Selection<SVGGElement, any, null, undefined>,
    xScale: d3.ScaleLinear<number, number>,
    yScale: d3.ScaleLinear<number, number>,
    attributesData: IPlayerAttributesPitchData[],
    tooltipRef: React.RefObject<HTMLDivElement>) => {

    const minVaep = d3.min(attributesData, d => d.vaep_score ?? 0);
    const maxVaep = d3.max(attributesData, d => d.vaep_score ?? 0);
    const maxPassCount = d3.max(attributesData, d => d.passCount) ?? 1;
    const colorScale = d3.scaleSequential(d3.interpolateOrRd).domain([minVaep!, maxVaep!]);
    attributesData.forEach((d) => {
        const rectX = xScale(d.location_x);
        const rectY = yScale(d.location_y);

        const rectWidth = xScale(5.25);
        const rectHeight = yScale(3.4);
        // 20 x 20 end

        // Ensure vaepScore is defined
        const vaepScore = d.vaep_score ?? 0;
        const passCount = d.passCount ?? 0;

        // Normalize passCount for opacity (scale between 0.2 and 1)
        const opacity = vaepScore === 0 ? 1 : d3.scaleLinear().domain([0, maxPassCount]).range([0.1, 1])(passCount);

        // Get fill color based on vaep_score
        const fillColor = getBackgroundColor(vaepScore);
        //const fillColor = "none";


        // Append the rectangle with dynamic color
        svg
            .append("rect")
            .attr("x", rectX)
            .attr("y", rectY)
            .attr("width", rectWidth)
            .attr("height", rectHeight)
            //.style("fill", vaepScore === 0 ? 'none' : fillColor)
            .style("fill", fillColor)
            .style("fill-opacity", opacity)
            .attr("stroke", "grey")
            .attr("stroke-width", 1);

        // Append text inside each box
        svg
            .append("text")
            .attr("x", rectX + rectWidth / 2)  // Center text horizontally
            .attr("y", rectY + rectHeight / 2) // Center text vertically
            .attr("text-anchor", "middle")  // Center align the text
            .attr("dominant-baseline", "middle") // Proper vertical centering
            .attr("font-size", "12px")
            .attr("font-weight", "bold")
            .attr("fill", vaepScore > (minVaep! + maxVaep!) / 2 || vaepScore === 0 ? "white" : "black") // Adjust text color based on background
            //.text(vaepScore.toFixed(2));  // Ensure it displays numbers properly
            .text(vaepScore);  // Ensure it displays numbers properly
    });
}